import { Pipe, PipeTransform } from '@angular/core';
import { RequirementPeriod } from '../../billing/interfaces/requirement-period';
import * as moment from 'moment';

/**
 * Formatiert den übergebenen Billing-Statuscode in einen menschenlesbaren string und gibt ihn zurück
 */
@Pipe({ name: 'displayRequirementPeriod' })
export class DisplayRequirementPeriodPipe implements PipeTransform {

  private _allowedModes = [
    'monthly',
    'yearly'
  ]

  private _monthNames = {
    1: 'Januar',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember'
  };

  transform(requirementPeriod: RequirementPeriod): string {
    if (requirementPeriod.start === null) {
      return '';
    }

    const mode = requirementPeriod.displayMode;
    const date = moment(requirementPeriod.start).toDate();
    if (this._allowedModes.includes(mode)) {
      if (mode === 'monthly') {
        // Hier muss um eins erhöht werden, da Javascript die Monate, beginnend mit 0 indiziert hat
        const monthNumber = date.getMonth() + 1;
        return this._monthNames[monthNumber] + ' ' + date.getFullYear();
      }

      if (mode === 'yearly') {
        return moment(requirementPeriod.start).format('YYYY');
      }
    }

    throw new Error("Es wurde kein korrekter Modus übergeben. Erlaubt sind: 'yearly', 'monthly'")
  }
}
